import { render, staticRenderFns } from "./spotMarket.vue?vue&type=template&id=c81a79fe&"
import script from "./spotMarket.vue?vue&type=script&lang=js&"
export * from "./spotMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports